import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import { tabletQuery } from '@globals/themes/themeConstants'
import useMediaQuery from '@mui/material/useMediaQuery'
import RouteLoading from '@shared/routing/RouteLoading'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const MeRoute = lazyWithRetries(() => import('../me'))
const MemberProfileRoute = lazyWithRetries(() => import('../memberProfile'))
const MeMobileRoute = lazyWithRetries(() => import('./mobile'))

const MeRouteWrapper = () => {
  const isTablet = useMediaQuery(tabletQuery)

  return (
    <Suspense fallback={<RouteLoading />}>{isTablet ? <MeMobileRoute /> : <MeRoute />}</Suspense>
  )
}

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.me(),
    element: <MeRouteWrapper />,
  },
  {
    path: AppPaths.tenant.memberProfile(':tenantMemberId'),
    element: (
      <Suspense fallback={<RouteLoading />}>
        <MemberProfileRoute />
      </Suspense>
    ),
  },
]

export default routes
